import type { SuperProperties } from "./types"

// userAgentData is a draft spec; cast to avoid missing DOM lib typings in some TS versions.
type UAData = { mobile?: boolean; platform?: string; brands?: { brand: string }[] }
const uaData = (): UAData | undefined =>
  (navigator as Navigator & { userAgentData?: UAData }).userAgentData

const detectOS = (): string => {
  const platform = uaData()?.platform
  if (platform) return platform
  const ua = navigator.userAgent
  if (/Windows/i.test(ua)) return "Windows"
  if (/Mac OS X/i.test(ua)) return "macOS"
  if (/Android/i.test(ua)) return "Android"
  if (/iPhone|iPad|iPod/i.test(ua)) return "iOS"
  if (/Linux/i.test(ua)) return "Linux"
  return "Unknown"
}

const detectBrowser = (): string => {
  const brands = uaData()?.brands
  if (brands) {
    const real = brands.find((b) => !b.brand.includes("Not") && b.brand !== "Chromium")
    if (real) return real.brand
  }
  const ua = navigator.userAgent
  if (/Edg\//i.test(ua)) return "Edge"
  if (/Firefox/i.test(ua)) return "Firefox"
  if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) return "Safari"
  if (/Chrome/i.test(ua)) return "Chrome"
  return "Unknown"
}

const detectDevice = (): "Mobile" | "Desktop" => {
  const mobile = uaData()?.mobile
  if (mobile != null) return mobile ? "Mobile" : "Desktop"
  return /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop"
}

// Snapshot is taken at push time (not flush time) so the context reflects
// the exact moment the event fired, not when the batch was sent.
export const collectSuperProperties = (): SuperProperties => ({
  theme: document.documentElement.classList.contains("dark") ? "dark" : "light",
  $screen_height: window.screen.height,
  $screen_width: window.screen.width,
  $current_url: window.location.href,
  $os: detectOS(),
  $browser: detectBrowser(),
  $device: detectDevice(),
  mp_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  $viewport_width: window.innerWidth,
  migrationSource: "nextjs",
})
